import React from 'react';
import { useTranslation } from '../../i18n';
import { useAuth } from '../../contexts/AuthContext';
import { SECTIONS } from './sections';
import styles from './SettingsSidebar.module.css';

function SettingsSidebar({ activeSection, onSelectSection, alertsExpanded, onToggleAlerts }) {
    const { t } = useTranslation('shell');
    const { user } = useAuth();

    const userInitials = (user?.firstName && user?.lastName)
        ? (user.firstName[0] + user.lastName[0]).toUpperCase()
        : 'US';
    const displayName = (user?.firstName && user?.lastName)
        ? `${user.firstName} ${user.lastName}`
        : '';

    return (
        <aside className={styles.sidebar}>
            <div className={styles.userBlock}>
                <div className={styles.avatar}>{userInitials}</div>
                {displayName && <div className={styles.userName}>{displayName}</div>}
            </div>

            <nav className={styles.sectionNav} role="navigation">
                <button
                    type="button"
                    className={`${styles.navItem} ${activeSection === SECTIONS.PROFILE ? styles.navItemActive : ''}`}
                    onClick={() => onSelectSection(SECTIONS.PROFILE)}
                >
                    {t('settings.sections.profile')}
                </button>
                <button
                    type="button"
                    className={`${styles.navItem} ${activeSection === SECTIONS.LANGUAGE ? styles.navItemActive : ''}`}
                    onClick={() => onSelectSection(SECTIONS.LANGUAGE)}
                >
                    {t('settings.sections.language')}
                </button>
                <button
                    type="button"
                    className={`${styles.navItem} ${styles.navItemExpandable}`}
                    onClick={onToggleAlerts}
                    aria-expanded={alertsExpanded}
                >
                    <span>{t('settings.sections.alerts')}</span>
                    <span
                        className={`${styles.caret} ${alertsExpanded ? styles.caretOpen : ''}`}
                        aria-hidden="true"
                    >
                        ▼
                    </span>
                </button>
                {alertsExpanded && (
                    <button
                        type="button"
                        className={`${styles.subNavItem} ${activeSection === SECTIONS.EVENTS ? styles.subNavItemActive : ''}`}
                        onClick={() => onSelectSection(SECTIONS.EVENTS)}
                    >
                        {t('settings.sections.eventsNotifications')}
                    </button>
                )}
            </nav>
        </aside>
    );
}

export default SettingsSidebar;